import axios, { AxiosError, AxiosInstance, AxiosResponse } from "axios";
import { getCookie } from "../../../supportFunctions/CookiesHelpers";

class AuthService {
  public api: () => AxiosInstance;
  public graphql: () => AxiosInstance;

  constructor() {
    this.api = () => {
      const api = axios.create({
        baseURL: process.env.REACT_APP_AUTH_API_URL,
        headers: { "Content-Type": "application/json;charset=UTF-8" },
      });

      this.addBearerTokenInterceptor(api);
      this.addGraphQLErrorInterceptor(api);
      return api;
    };

    this.graphql = () => {
      const api = axios.create({
        baseURL: process.env.GRAPHQL_GATEWAY_URL,
        headers: { "Content-Type": "application/json;charset=UTF-8" },
      });

      this.addBearerTokenInterceptor(api);
      this.addGraphQLErrorInterceptor(api);
      return api;
    };
  }

  private addGraphQLErrorInterceptor = (axiosInstance: AxiosInstance) => {
    axiosInstance.interceptors.response.use(
      (response: AxiosResponse) => {
        let errors = response?.data?.errors;
        if (errors) {
          // eslint-disable-next-line
          throw { response };
        } else {
          return response;
        }
      },
      (error: AxiosError) => {
        throw error;
      }
    );
  };

  private addBearerTokenInterceptor(axiosInstance: AxiosInstance) {
    axiosInstance.interceptors.request.use((config) => {
      //@ts-ignore
      config.headers["Authorization"] = "Bearer " + this.getJwt();
      return config;
    });
  }

  private getJwt() {
    return getCookie("accelerate.jwt") || "";
  }
}

export default new AuthService();
